import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SurveyFormSectionProps {
  children: ReactNode;
  className?: string;
  ariaLabelledBy?: string;
}

export function SurveyFormSection({ children, className, ariaLabelledBy }: SurveyFormSectionProps) {
  return (
    <section
      aria-labelledby={ariaLabelledBy}
      className={cn('flex flex-col gap-4 rounded-xl border bg-card p-5 shadow-sm', className)}
    >
      {children}
    </section>
  );
}
